import { Pipe, PipeTransform } from "@angular/core";

import { Basket } from "@hermes/api-model-basket";

@Pipe({ name: "cartLabel" })
export class CartLabelPipe implements PipeTransform {
    public transform(basket: Basket | undefined | null): string {
        if (basket?.totalItems === 1) {
            return $localize`:@@hermes.accessibility.cart_single:item`;
        } else if (basket?.totalItems && basket.totalItems > 1) {
            return $localize`:@@hermes.accessibility.cart_plural:items`;
        }

        return $localize`:@@hermes.accessibility.cart_empty:empty`;
    }
}
